import script from "./NavbarLogged.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarLogged.vue?vue&type=script&setup=true&lang=js"

import "./NavbarLogged.vue?vue&type=style&index=0&id=489674f6&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-489674f6"]])

export default __exports__